function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "67",
  height: "66",
  fill: "none"
}, props), /*#__PURE__*/React.createElement("rect", {
  x: "2.125",
  y: "1",
  width: "64",
  height: "64",
  rx: "4",
  fill: "#454B5E"
}), /*#__PURE__*/React.createElement("rect", {
  x: "13.625",
  y: "10",
  width: "39",
  height: "4",
  rx: "1",
  fill: "#D2D6DB"
}), /*#__PURE__*/React.createElement("rect", {
  x: "13.625",
  y: "16",
  width: "39",
  height: "4",
  rx: "1",
  fill: "#D2D6DB"
}), /*#__PURE__*/React.createElement("rect", {
  x: "13.625",
  y: "39",
  width: "18",
  height: "19",
  rx: "1",
  fill: "#D2D6DB"
}), /*#__PURE__*/React.createElement("rect", {
  x: "34.625",
  y: "39",
  width: "18",
  height: "19",
  rx: "1",
  fill: "#D2D6DB"
}), /*#__PURE__*/React.createElement("rect", {
  x: "13.625",
  y: "22",
  width: "39",
  height: "14",
  rx: "2",
  fill: "#D2D6DB"
}), /*#__PURE__*/React.createElement("rect", {
  x: "1.375",
  y: ".5",
  width: "65",
  height: "65",
  rx: "4.5",
  fill: "url(#paint0_linear_2_4842)",
  stroke: "#7E86A0"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_2_4842",
  x1: "33.75",
  y1: "65",
  x2: "33.75",
  y2: "1",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#454B5E",
  stopOpacity: ".76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".336",
  stopColor: "#454B5E",
  stopOpacity: ".58"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#454B5E",
  stopOpacity: ".39"
})))));